import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { App as AntdAppContext, ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import { HelmetProvider } from "react-helmet-async";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { ErrorProvider } from "~components/ErrorHandler/ErrorProvider";
import { mainTheme } from "~utils/themes";
import { setupLanguage } from "./App.i18n";
import { ReactQueryProvider } from "./app/api/ReactQueryProvider";
import { AuthProvider } from "./auth";
import Routes from "./routes";

const App = () => {
  const { locale, messages } = setupLanguage();

  return (
    <BrowserRouter>
      <AuthProvider>
        <IntlProvider locale={locale} messages={messages}>
          <ReactQueryProvider>
            <ConfigProvider
              locale={{
                ...enUS,
                Pagination: {
                  ...enUS.Pagination,
                  items_per_page: "",
                },
              }}
              theme={{
                token: {
                  fontFamily: "Roboto Regular, sans-serif",
                  fontSizeHeading2: 28,
                  fontSizeHeading4: 18,
                },
                components: {
                  Table: {
                    headerBg: "#FFFFFF",
                    headerBorderRadius: 0,
                    headerSplitColor: "#ffffff",
                  },
                  Form: {
                    itemMarginBottom: 16,
                  },
                  Tabs: {
                    horizontalItemPadding: "13px 15px 16px 15px",

                    itemHoverColor: "#df120f",
                    itemActiveColor: "#df120f",
                    itemSelectedColor: "#df120f",
                    inkBarColor: "#df120f",
                  },
                  Button: {
                    contentFontSize: 16,
                    fontWeight: 600,
                  },
                },
              }}
            >
              <ThemeProvider theme={mainTheme}>
                <AntdAppContext notification={{ placement: "bottomRight", maxCount: 3 }}>
                  <HelmetProvider>
                    <ErrorProvider>
                      <Routes />
                    </ErrorProvider>
                  </HelmetProvider>
                </AntdAppContext>
              </ThemeProvider>
            </ConfigProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </ReactQueryProvider>
        </IntlProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
